import { useEffect, useState } from "react";
import Loader from "../components/Loader/Loader";
import Page from "../components/Page";
import { useDispatch, useSelector } from "react-redux";
import { loginBroker } from "../redux/auth/actions";

const FromSSOPage = () => {

    const dispatch = useDispatch();
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const token = params.get('token');

    const [isLoading, setIsLoading] = useState(true)


    useEffect(() => {

        


        dispatch(
            loginBroker({
                action: "realtor_login_from_php",
                token: token
            })
        );
    }, [])




    return (
        <>
            <Loader start={isLoading} />

        </>
    );
}

export default FromSSOPage;